<template>
  <component :is="tag" :href="href" v-on="$listeners" v-bind="attrs" class="hero-button">
    <slot></slot>
  </component>
</template>

<script>
  import { IconMap } from "../ui"

  export default {
    name: "HeroButton",
    props: {
      tag: {
        type: String,
        default: "button"
      },
      href: {
        default: false
      }
    },
    computed: {
      attrs() {
        const {tag, ...attrs} = this.$attrs;

        return attrs
      }
    },
    components: { IconMap }
  }
</script>